import { useIsLaptop, useIsTablet } from '@synoptic/ui-kit/responsive/hooks.js';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@synoptic/ui-kit/tooltip/tooltip.js';
import clsx from 'clsx';
import { FC } from 'react';
import { HeaderLogo } from './header-logo.tsx';
import { Menu } from './menu/menu.tsx';
import { NavButton } from './nav-button.tsx';
import { ProfileMenu } from './profile-menu.tsx';
import { useSidebarContext } from './sidebar-context.tsx';
import {
  sidebarBody,
  sidebarCollapseButtonContainer,
  sidebarCollapseButtonTooltipArrow,
  sidebarCollapseButtonTooltipContent,
  sidebarInner,
  sidebarWrapper,
  sidebarWrapperCollapsed,
} from './sidebar.css.ts';

export const Sidebar: FC = () => {
  const isTablet = useIsTablet();
  const isLaptop = useIsLaptop();
  const { isCollapsed, setIsCollapsed } = useSidebarContext();

  return (
    <div
      className={clsx(sidebarWrapper, {
        [sidebarWrapperCollapsed]: isCollapsed,
      })}
    >
      <div className={sidebarInner}>
        {isTablet ? <HeaderLogo /> : null}
        <div className={sidebarBody}>
          {isLaptop && (
            <Tooltip disableHoverableContent>
              <TooltipTrigger asChild>
                <NavButton
                  collapsed={isCollapsed}
                  className={sidebarCollapseButtonContainer}
                  onClick={() => setIsCollapsed((collapsed) => !collapsed)}
                />
              </TooltipTrigger>
              <TooltipContent
                color="prominent"
                className={sidebarCollapseButtonTooltipContent}
                arrowClassName={sidebarCollapseButtonTooltipArrow}
                side="right"
                description={isCollapsed ? 'Expand menu' : 'Collapse menu'}
              />
            </Tooltip>
          )}
          <Menu />

          {isTablet ? <ProfileMenu /> : null}
        </div>
      </div>
    </div>
  );
};
